import script from "./RegionSelectorMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionSelectorMobile.vue?vue&type=script&setup=true&lang=js"

import "./RegionSelectorMobile.vue?vue&type=style&index=0&id=2091eeba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2091eeba"]])

export default __exports__